import { logError } from '@/utils/errorReporter'
import { parseMarketingData } from './marketingDataSchema'

export default class MarketingDataApi {
  baseUrl = 'https://cdn.ecoonline.com/marketing/taxonomy'

  async fetchMarketingData() {
    try {
      const manifestRes = await fetch(`${this.baseUrl}/manifest.json`)
      if (!manifestRes.ok) throw new Error(`Manifest fetch failed: HTTP ${manifestRes.status}`)
      const manifest = await manifestRes.json()

      const dataUrl = `${this.baseUrl}/v${manifest?.active_version}.json`
      const dataRes = await fetch(dataUrl)
      if (!dataRes.ok) throw new Error(`Marketing data fetch failed: HTTP ${dataRes.status}`)
      return parseMarketingData(await dataRes.json())
    } catch (e) {
      logError(e, { source: 'MarketingDataApi.fetchMarketingData' })
      return undefined
    }
  }
}
